export default function MailIcon() {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g id="ic mail">
            <rect
               id="Rectangle 1350"
               x="3"
               y="5"
               width="18"
               height="14"
               rx="2"
               stroke="currentColor"
               strokeWidth="2"
            />
            <path
               id="Vector 324"
               d="M3 8V7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V8L12 12L3 8Z"
               stroke="currentColor"
               strokeWidth="2"
            />
         </g>
      </svg>
   )
}
